import type { TvCategory } from '@setplex/tria-api'

export const CategoryType = {
  // used also as `sortOrder` value
  Favorite: -3,
  All: -2,
  Featured: -1,
  Regular: 0,
} as const
export type CategoryType = (typeof CategoryType)[keyof typeof CategoryType]

export type TvCategoryEx = TvCategory & {
  type: CategoryType
  channelIds: readonly number[]
}

export const CategoryId = {
  Favorite: -2,
  Featured: -1,
  All: 0,
  Regular: NaN, // real category id is used instead
} as const
export type CategoryId = (typeof CategoryId)[keyof typeof CategoryId]
